import type {FC, ReactNode} from 'react';
import clsx from 'clsx';

import {ContentBlockHeading} from '@/modules/foundation/components/content-block-heading';
import type {PortableTextOverrides} from '@/modules/foundation/sanity/portable-text';
import type {KeyedArray} from '@/modules/foundation/shared/types';
import {
	ContentBlockContainer,
	type ContentBlockContainerProps,
} from '@/modules/page/components/content-blocks/block-container';

import type {ArticleDetails} from '../../shared/types';
import {ArticleCard} from '../article-card';

interface Props extends ContentBlockContainerProps {
	heading?: string;
	description?: ReactNode;
	articles: KeyedArray<ArticleDetails>;
	anchorHeadings?: boolean;
	insideToc?: boolean;
}

export const articleListLatestDescriptionPortableTextOverrides: PortableTextOverrides = {
	p: 'text-xl',
};

const ArticleList: FC<Props> = ({
	heading,
	description,
	options,
	articles,
	anchorHeadings,
	insideToc,
}) => {
	return (
		<ContentBlockContainer options={options} insideToc={insideToc}>
			<div className={clsx('@container')}>
				<ContentBlockHeading heading={heading} anchorHeading={anchorHeadings}>
					{description}
				</ContentBlockHeading>

				<ul className={clsx('grid', 'gap-10', '@4xl:grid-cols-3')}>
					{articles && (
						<>
							{articles.map((article) => {
								return (
									<li key={article._key}>
										<ArticleCard
											article={article}
											headingLevel={heading ? 3 : 2}
										/>
									</li>
								);
							})}
						</>
					)}
				</ul>
			</div>
		</ContentBlockContainer>
	);
};
export default ArticleList;
